import { useState } from 'react';

export const useModalState = (initialItem = null) => {
    const [isOpen, setIsOpen] = useState(false);
    const [item, setItem] = useState(initialItem);

    const open = (selectedItem = null) => {
        setItem(selectedItem);
        setIsOpen(true);
    };

    const close = () => {
        setItem(initialItem);
        setIsOpen(false);
    };

    return { isOpen, item, open, close };
};

export default useModalState;
